import classNames from 'classnames';
import React from 'react';
import { useVideoConfig } from '../../video/video-config-provider';
import s from './icon-button.scss';
export var IconButton = function (_a) {
    var _b;
    var dataHook = _a.dataHook, className = _a.className, Icon = _a.Icon, onClick = _a.onClick;
    var mobile = useVideoConfig().mobile;
    return (React.createElement("button", { "data-hook": dataHook, className: classNames(s.container, className, (_b = {}, _b[s.mobile] = mobile, _b)), onClick: onClick },
        React.createElement(Icon, { size: 16 })));
};
//# sourceMappingURL=icon-button.js.map